import React, { Component } from "react";
import { Grid, Box } from "@mui/material";
import TableList from "./CustomTool/TableList";
import CtTxt from "./CustomTool/CtTxt";
import CtBtn from "./CustomTool/CtBtn";
import CtCmb from "./CustomTool/CtCmb";
import { Edit, Delete, Print } from "@mui/icons-material";
import Progress from "./CustomTool/Progress";
import CtCheckBox from "./CustomTool/CtCheckBox";
import CtMultiLineText from "./CustomTool/CtMultiLineText";
import { connect } from "react-redux";
import {
  mapStatetoProps,
  mapSetActiveMenu_MenuVisibility_ToProps,
} from "../mapRedux/mapReduxProps";
//import { fetchLedgerDetail } from './API'
import AlertResponsiveDialog from "./CustomTool/AlertResponsiveDialog";
import HoCtToastContainer from "../HOC/HoCtToastContainer";
import { fetchTaxMaster } from "./API";
import HOCVerifyIsUser from "../HOC/HOCVerifyIsUser";

class TaxMaster extends Component {
  state = {
    CompanyName: [],
    LedgerType: [],
    BalaneSheet: [],
    columns: [
      { id: "Action", label: "Search", name: "Search" },
      //  { id: 'bint_srno', label: 'SR NO' },
      { id: "vac_CompanyName", label: "Tax Name" },
      { id: "vac_LegderName", label: "CGST" },
      { id: "vac_LegderType", label: "SGST" },
      { id: "int_LegderCode", label: "IGST" },
    ],
    rows: [],
    actionList: [
      {
        name: "Edit",
        icon: <Edit />,
        link: "TaxMaster:",
        actionType: "AlertResponsive",
      },
      {
        name: "Delete",
        icon: <Delete />,
        link: "TaxMaster:",
        actionType: "AlertResponsive",
      },
    ],
    keyColumn: [
      "bint_srno",
      "vac_CompanyName",
      "vac_LegderName",
      "vac_LegderType",
      "int_LegderCode",
      "dec_OpeningBalance",
      "vac_BalanceSheet",
      "vac_trading",
      "vac_profitloss",
    ],

    formData: {
      bint_srno: "",
      txtTaxName: "",
      txtCGST: "",
      txtSGST: "",
      txtIGST: "",
    },

    searchData: {
      nvac_TaxName: "",
      dec_CGST: "",
      dec_SGST: "",
      dec_IGST: "",
    },
    searchColumns: [],
    searchRows: [],
    searchOpen: false,
    searchRowsCount: 0,

    dataLoadStatus: true,
    ARD: null,
    rowsCount: 0,
    rowsPerPage: 50,
  };

  //#region Component
  componentDidMount() {
    document.title = "RiTe Account : Tax Master";
    this.props.setActiveMenu("TaxMaster");
    this.props.verifyUserID(
      this.getInfo,
      this.props.navInfo.subMenuMaster,
      this.props.setSubMenu_Master_Entry,
      this.props.setUserPrivileges
    );
    this.setSearchColumns();
  }
  //#endregion Component

  //#region handle
  handleOnChange = (e) => {
    this.setState({
      formData: { ...this.state.formData, [e.target.name]: e.target.value },
    });
  };

  handleChangeRowsPerPage = (rowsPerPage) => {
    this.setState({ rowsPerPage });
  };

  setSearchColumns = () => {
    let searchColumns = [];
    searchColumns.push(
      {
        cType: "CtTxt",
        id: "nvac_TaxName",
        label: "Tax name",
        value: this.state.searchData.nvac_TaxName,
        handleOnChange: this.handleOnSearchInputChange,
        width: "200",
        maxLength: "100",
      },
      {
        cType: "CtTxt",
        id: "dec_CGST",
        label: "CGST",
        value: this.state.searchData.dec_CGST,
        handleOnChange: this.handleOnSearchInputChange,
        width: "200",
        maxLength: "100",
      },
      {
        cType: "CtTxt",
        id: "dec_SGST",
        label: "SGST",
        value: this.state.searchData.dec_SGST,
        handleOnChange: this.handleOnSearchInputChange,
        width: "200",
        maxLength: "100",
      },
      {
        cType: "CtTxt",
        id: "dec_IGST",
        label: "IGST",
        value: this.state.searchData.dec_IGST,
        handleOnChange: this.handleOnSearchInputChange,
        width: "200",
        maxLength: "100",
      }
    );
    this.setState({ searchColumns });
  };

  handleOnSearchInputChange = (e) => {
    // console.log('handleOnSearchInputChange', [e.target.name], e.target.value, this.state.searchData);
    this.setState(
      {
        searchData: {
          ...this.state.searchData,
          [e.target.name]: e.target.value,
        },
      },
      () => {
        this.handleOnSearchChange(this.state.searchOpen, this.state.searchData);
        // console.log(this.state.searchData)
      }
    );
  };

  handleOnSearchInputChangeTrim = (e) => {
    this.setState(
      {
        searchData: {
          ...this.state.searchData,
          [e.target.name]: e.target.value.trim(),
        },
      },
      () => {
        this.handleOnSearchChange(this.state.searchOpen, this.state.searchData);
      }
    );
  };

  handleOnSearchChange = (searchOpen) => {
    let searchRows = [];
    if (searchOpen === true && this.state.rows.length > 0) {
      this.state.rows.map((row) => {
        if (
          searchOpen === true &&
          (this.state.searchData.nvac_GroupName.length === 0 ||
            (row["nvac_GroupName"] &&
              row["nvac_GroupName"]
                .toString()
                .toLowerCase()
                .includes(
                  this.state.searchData.nvac_GroupName.toLowerCase()
                ))) &&
          (this.state.searchData.dec_CGST.length === 0 ||
            (row["dec_CGST"] &&
              row["dec_CGST"]
                .toString()
                .toLowerCase()
                .includes(this.state.searchData.dec_CGST.toLowerCase()))) &&
          (this.state.searchData.dec_SGST.length === 0 ||
            (row["dec_SGST"] &&
              row["dec_SGST"]
                .toString()
                .toLowerCase()
                .includes(this.state.searchData.dec_SGST.toLowerCase()))) &&
          (this.state.searchData.dec_IGST.length === 0 ||
            (row["dec_IGST"] &&
              row["dec_IGST"]
                .toString()
                .toLowerCase()
                .includes(this.state.searchData.dec_IGST.toLowerCase())))
        ) {
          searchRows.push(row);
        }
      });
      const searchRowsCount = searchRows.length;
      this.setState(
        {
          searchOpen,
          searchRows,
          searchRowsCount,
          counter: this.state.counter + 1,
        },
        () => {}
      );
    } else {
      this.setState({ searchOpen });
    }
  };

  handleARDonActionClick = (row) => {
    // console.log("values", values);
    const bint_srno = row.bint_srno,
      cmbCompanyName = row.vac_CompanyName,
      txtLegderName = row.vac_LegderName,
      cmbLegderType = row.vac_LegderType,
      txtLegderCode = row.int_LegderCode,
      txtOpeningBalance = row.dec_OpeningBalance,
      cmbBalanceSheet = row.vac_BalanceSheet,
      chktrading = row.vac_trading,
      chkprofitloss = row.vac_profitloss,
      actionName = row.actionName;
    if (actionName === "Edit") {
      this.setState({
        formData: {
          ...this.state.formData,
          bint_srno,
          cmbCompanyName,
          txtLegderName,
          cmbLegderType,
          txtLegderCode,
          txtOpeningBalance,
          cmbBalanceSheet,
          chktrading,
          chkprofitloss,
        },
      });
    } else if (actionName === "Delete") {
      this.setState({ ARD: null }, () => {
        let ARD = (
          <AlertResponsiveDialog
            labelAgree="Delete"
            labelDisagree="Cancel"
            alertTitle={"Do you want to Delete  : " + bint_srno + " ?"}
            alertMessage=""
            handleOnClickYes={() => {
              return this.DeleteLedgerDetail(bint_srno);
            }}
            defaultOpenDialog={true}
            onYesClickCloseIfExeSuccessfully={true}
          />
        );

        this.setState({ ARD });
      });
    } else {
      let rows = this.state.rows.filter((row) => {
        if (
          row.bint_srno !== bint_srno &&
          row.vac_CompanyName !== cmbCompanyName &&
          row.vac_LegderName !== txtLegderName &&
          row.vac_LegderType !== cmbLegderType &&
          row.int_LegderCode !== txtLegderCode &&
          row.dec_OpeningBalance !== txtOpeningBalance &&
          row.vac_BalanceSheet !== cmbBalanceSheet &&
          row.vac_trading !== chktrading &&
          row.vac_profitloss !== chkprofitloss
        )
          return row;
      });
      const rowsCount = rows.length;
      this.setState({ rows, rowsCount });
    }
  };
  //#endregion handle

  //#region function
  validateTaxMaster = () => {
    let result = false;
    if (this.state.formData.txtTaxName.length <= 0) {
      this.props.toastErrorMsg("Enter Tax Name", "txtTaxName");
    } else {
      result = true;
    }
    return result;
  };

  getInfo = () => {
    let dataLoadStatus = false;
    this.setState({ dataLoadStatus }, () => {
      const reqData = {
        Op: "TaxMasterList",
      };
      fetchTaxMaster(reqData)
        .then((res) => {
          dataLoadStatus = true;
          let rows = res.data.TaxMasterList,
            rowsCount = rows.length;
          this.setState(
            {
              dataLoadStatus,
              rows,
              rowsCount,
            },
            () => {
              if (this.props.refreshTaxNameList) {
                this.props.refreshTaxNameList(rows);
              }
            }
          );
        })
        .catch((error) => {
          console.log("Unknown error occurred in onFormLoad.", error);
        });
    });
  };

  clearInfo = () => {
    const txtTaxName = "",
      txtCGST = "",
      txtSGST = "",
      txtIGST = "";

    this.setState(
      {
        formData: {
          ...this.state.formData,
          txtTaxName,
          txtCGST,
          txtSGST,
          txtIGST,
        },
      },
      () => {
        document.getElementById("txtTaxName").focus();
      }
    );
  };

  SaveTaxMaster = () => {
    if (this.validateTaxMaster()) {
      const dataLoadStatus = false;
      this.props.notifyProcessing();
      this.setState({ dataLoadStatus }, () => {
        const reqData = {
          Op: "SaveTaxMaster",
          vac_TaxName: this.state.formData.txtTaxName,
          dec_CGST: this.state.formData.txtCGST,
          dec_CGSTAmo: "",
          dec_SGST: this.state.formData.txtSGST,
          dec_SGSTAmo: "",
          dec_IGST: this.state.formData.txtIGST,
          dec_IGSTAmo: "",
        };
        fetchTaxMaster(reqData)
          .then((res) => {
            this.props.updateProcessing(res.data.msgType, res.data.message);
            if (res.data.msgType === "success") {
              this.getInfo();
              this.clearInfo(true);
            }
          })
          .catch((error) => {
            console.log("Unknown error occurred in SaveLedgerDetail.", error);
          });
      });
    }
  };

  DeleteTaxMaster = (txtTaxName) => {
    this.props.notifyProcessing();
    this.setState({ dataLoadStatus: false }, () => {
      const reqData = {
        Op: "DeleteTaxMaster",
        vac_TaxName: txtTaxName,
      };
      fetchTaxMaster(reqData)
        .then((res) => {
          this.props.updateProcessing(res.data.msgType, res.data.message);
          if (res.data.msgType === "success") {
            this.setState({ ARD: null }, () => {
              this.getInfo();
            });
          } else {
            this.setState({ dataLoadStatus: true });
          }
        })
        .catch((error) => {
          this.props.updateProcessing(
            "error",
            "Unknown error occurred in delete DeleteTaxMaster. " + error
          );
        });
    });
    return false;
  };
  //#endregion function

  render() {
    let rows = this.state.searchOpen ? this.state.searchRows : this.state.rows;
    let rowsCount = this.state.searchOpen
      ? this.state.searchRowsCount
      : this.state.rowsCount;

    return (
      <div>
        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="center"
          className="title"
        >
          <label htmlFor="Title" style={{ fontSize: "30px", color: "#515151" }}>
            <b>Tax Master</b>
          </label>
        </Grid>
        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="center"
          spacing={0}
          marginTop={0}
        >
          <Grid item>
            <Grid
              container
              direction="row"
              justifyContent="flex-start"
              alignItems="center"
              spacing={2}
              marginTop={0}
            >
              <Grid item>
                <CtTxt
                  id="txtTaxName"
                  value={this.state.formData.txtTaxName}
                  label="Tax Name"
                  handleOnChange={this.handleOnChange}
                  width={170}
                  maxLength={20}
                />
              </Grid>
              <Grid item>
                <CtTxt
                  id="txtCGST"
                  value={this.state.formData.txtCGST}
                  label="CGST"
                  handleOnChange={this.handleOnChange}
                  width={170}
                  maxLength={15}
                />
              </Grid>
              <Grid item>
                <CtTxt
                  id="txtSGST"
                  value={this.state.formData.txtSGST}
                  label="SGST"
                  handleOnChange={this.handleOnChange}
                  width={170}
                  maxLength={15}
                />
              </Grid>
              <Grid item>
                <CtTxt
                  id="txtIGST"
                  value={this.state.formData.txtIGST}
                  label="IGST"
                  handleOnChange={this.handleOnChange}
                  width={170}
                  maxLength={15}
                />
              </Grid>
            </Grid>
            <Grid
              container
              direction="row"
              justifyContent="center"
              alignItems="center"
              spacing={2}
              marginTop={0}
            >
              <Grid item>
                <CtBtn label="Save" onClick={this.SaveTaxMaster} />
              </Grid>
              <Grid item>
                <CtBtn label="New" onClick={this.clearInfo} />
              </Grid>
              <Grid item>
                <CtBtn label="Delete" />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="center"
          marginTop={5}
        >
          <TableList
            columns={this.state.columns}
            counter={this.state.counter}
            rows={rows}
            rowsCount={rowsCount}
            rowsPerPage={this.state.rowsPerPage}
            handleChangeRowsPerPage={this.handleChangeRowsPerPage}
            handleOnActionClick={this.handleARDonActionClick}
            actionList={this.state.actionList}
            keyColumn={this.state.keyColumn}
            handleOnSearchChange={this.handleOnSearchChange}
            searchColumns={this.state.searchColumns}
            searchData={this.state.searchData}
            provideSearch={true}
            // provideSearch={true}
            handleOnNewEntryClick={this.handleOnNewEntryClick}
            // toolTipNewEntry='New Product Entry'
          />
        </Grid>
        <Grid item>
          <Box display={{ xs: "none" }} style={{ textAlign: "right" }}>
            {this.state.ARD}
          </Box>
        </Grid>
      </div>
    );
  }
}

export default connect(
  mapStatetoProps,
  mapSetActiveMenu_MenuVisibility_ToProps
)(HOCVerifyIsUser(HoCtToastContainer(TaxMaster)));
